import React from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Box,
  useTheme,
  useMediaQuery,
} from '@mui/material';
import { Link, useLocation } from 'react-router-dom';
import HomeIcon from '@mui/icons-material/Home';
import LoginIcon from '@mui/icons-material/Login';
import PersonAddIcon from '@mui/icons-material/PersonAdd';

export default function AuthHeader() {
  const location = useLocation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const isLoginPage = location.pathname === '/login';
  const isRegisterPage = location.pathname === '/register';

  return (
    <AppBar position="static" elevation={1}>
      <Toolbar>
        {/* Logo/Brand */}
        <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
          <Button
            color="inherit"
            component={Link}
            to="/"
            startIcon={<HomeIcon />}
            sx={{ textTransform: 'none', fontSize: '1.25rem' }}
          >
            Meeting Rooms
          </Button>
        </Typography>

        {/* Navigation Links */}
        <Box sx={{ display: 'flex', gap: isMobile ? 1 : 2 }}>
          {!isLoginPage && (
            <Button
              color="inherit"
              component={Link}
              to="/login"
              startIcon={!isMobile ? <LoginIcon /> : null}
              variant={isRegisterPage ? 'outlined' : 'text'}
              sx={{ 
                color: 'white',
                borderColor: isRegisterPage ? 'white' : 'transparent'
              }}
            >
              Login
            </Button>
          )}
          
          {!isRegisterPage && (
            <Button
              color="inherit"
              component={Link}
              to="/register"
              startIcon={!isMobile ? <PersonAddIcon /> : null}
              variant={isLoginPage ? 'outlined' : 'text'}
              sx={{ 
                color: 'white',
                borderColor: isLoginPage ? 'white' : 'transparent'
              }}
            >
              Register
            </Button>
          )}
        </Box>
      </Toolbar>
    </AppBar>
  );
} 